<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" (menuOpened)="loadMicroserviciosStatus()">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar"
        />
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="'heroicons_outline:user-circle'"
        ></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{
                'mr-px mb-px': !showAvatar || !user.avatar,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible'
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="py-8 px-4 bg-zinc-200">
        <div class="flex flex-col gap-1">
            <span>Inicio sesión con:</span>
            <span class="text-md flex items-center gap-1 font-bold">
                <mat-icon
                    [svgIcon]="'heroicons_outline:user'"
                    class="icon-size-5"
                ></mat-icon>
                {{ user.name }}</span
            >
            <span class="text-md flex items-center gap-1 font-bold">
                <mat-icon
                    [svgIcon]="'heroicons_outline:envelope'"
                    class="icon-size-5"
                ></mat-icon
                >{{ user.email }}</span
            >
        </div>
    </div>
    <!-- <mat-divider class="my-2"></mat-divider> -->
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button>
    <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button> -->
    <button mat-menu-item (click)="cambiarPassword()">
        <mat-icon
            [svgIcon]="'heroicons_outline:lock-reset'"
        ></mat-icon>
        <span>Cambiar Contraseña</span>
    </button>
    <button mat-menu-item (click)="cargarTicket()">
        <mat-icon
            [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"
        ></mat-icon>
        <span>Listado de Tickets</span>
    </button>
    <button mat-menu-item (click)="openBuscadorModulos()">
        <mat-icon
            [svgIcon]="'heroicons_outline:magnifying-glass'"
        ></mat-icon>
        <span>Buscador de módulos</span>
    </button>

    <!-- Estado Microservicios -->
    <ng-container *ngIf="microservicios.length > 0">
        <mat-divider class="my-2"></mat-divider>
        <div class="px-4 py-2 bg-slate-50/50">
            <span class="text-[10px] font-bold uppercase tracking-wider text-secondary opacity-60">Estado Recursos Externos</span>
            <div class="mt-2 flex flex-col gap-2">
                <div *ngFor="let svc of microservicios" class="flex items-center gap-2">
                    <span class="w-2 h-2 rounded-full shadow-sm" 
                          [ngClass]="svc.activo ? 'bg-green-500' : 'bg-red-500'"></span>
                    <span class="text-[11px] font-medium text-gray-700">{{ svc.nombre }}</span>
                </div>
            </div>
        </div>
    </ng-container>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Cerrar Sesión</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">

    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
